import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Dominio canónico del sitio (versión sin www).
 *
 * Todas las URLs canónicas apuntan aquí para evitar contenido duplicado
 * (www vs sin www, http vs https, trailing slash) reportado por Google
 * Search Console como "Duplicate without user-selected canonical".
 */
const CANONICAL_BASE = 'https://micampodigital.com.ar';

/**
 * Normaliza una ruta a su forma canónica:
 * - Sin trailing slash (salvo la raíz "/")
 * - Sin query params ni hash (se ignoran en el href)
 */
function normalizePath(pathname: string): string {
  let path = pathname || '/';
  if (path.length > 1 && path.endsWith('/')) {
    path = path.slice(0, -1);
  }
  return path;
}

/**
 * Inserta/actualiza `<link rel="canonical">` en el `<head>` según la ruta actual.
 *
 * Debe usarse dentro de `<Router>` (usa `useLocation`). Reacciona a la
 * navegación client-side, así cada página pública declara su propia URL
 * canónica en lugar de compartir la del home.
 */
const Canonical: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const href = `${CANONICAL_BASE}${normalizePath(location.pathname)}`;

    let link = document.querySelector<HTMLLinkElement>('head > link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'canonical';
      document.head.appendChild(link);
    }
    link.setAttribute('href', href);
  }, [location.pathname]);

  return null;
};

export default Canonical;
